export const PRODUCT_NAME = 'COMBO COMPLETO ELECTRICISTAS';
export const PRODUCT_PRICE = 19990;
export const PRODUCT_CURRENCY = 'ARS';
export const CHECKOUT_URL = 'https://combo-completo-electricistas.impultienda.ar/checkout';
export const OFFER_ANCHOR = '#offer';
export const META_PIXEL_ID = '3123699361155808';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/uhG78FGubFk35GYfdm8RfX/Combo_completo_para_electricistas.png';
export const SUPPORT_EMAIL = 'compradigitalyaa@gmail.com';

// Links editables del footer — reemplazá "#" por las URLs reales de tus páginas legales.
export const FOOTER_LINKS = [
  { label: 'Términos y condiciones', href: '#' },
  { label: 'Política de privacidad', href: '#' },
  { label: 'Política de reembolsos', href: '#' },
  { label: 'Contacto', href: `mailto:${SUPPORT_EMAIL}` },
];

// Formato de pesos argentinos: 19990 → $19.990
export const formatPrice = (value: number) =>
  `$${Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
